// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SensorListModel from '../../model/sensor-list-model';
import SensorListDTO from '../dto/sensor-list-dto';
import dtoSchema from '../schemas/sensor-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SensorListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SensorListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.customer = data.customer ?? undefined;
      this.project = data.project ?? undefined;
      this.object = data.object ?? undefined;
      this.sensorId = data.sensorId ?? undefined;
      this.sensorTyp = data.sensorTyp ?? undefined;
      this.sensorConfig = data.sensorConfig ?? undefined;
      this.valueHex = data.valueHex ?? undefined;
      this.value1 = data.value1;
      this.unit1 = data.unit1 ?? undefined;
      this.value2 = data.value2;
      this.unit2 = data.unit2 ?? undefined;
      this.measurementTime = data.measurementTime;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  customer?: string;
  /**
  */
  project?: string;
  /**
  */
  object?: string;
  /**
  */
  sensorId?: string;
  /**
  */
  sensorTyp?: string;
  /**
  */
  sensorConfig?: string;
  /**
  */
  valueHex?: string;
  /**
  * @type {double}
  */
  value1?: number;
  /**
  */
  unit1?: string;
  /**
  * @type {double}
  */
  value2?: number;
  /**
  */
  unit2?: string;
  /**
  * @type {date-time}
  */
  measurementTime?: string;

  static toModel(dto: DeepPartial<SensorListDTO>): SensorListModel;
  static toModel(dto: DeepPartial<SensorListDTO> | undefined | null): SensorListModel | undefined;
  static toModel(dto: DeepPartial<SensorListDTO> | undefined | null): SensorListModel | undefined {
    return dto ? new SensorListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SensorListModel> | SensorListModel): SensorListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      customer: unwrapped.customer,
      project: unwrapped.project,
      object: unwrapped.object,
      sensorId: unwrapped.sensorId,
      sensorTyp: unwrapped.sensorTyp,
      sensorConfig: unwrapped.sensorConfig,
      valueHex: unwrapped.valueHex,
      value1: unwrapped.value1,
      unit1: unwrapped.unit1,
      value2: unwrapped.value2,
      unit2: unwrapped.unit2,
      measurementTime: unwrapped.measurementTime,
    } as SensorListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SensorListModel, can not map to SensorListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
